import { render, staticRenderFns } from "./0021.vue?vue&type=template&id=99622798&scoped=true&"
import script from "./0021.vue?vue&type=script&lang=js&"
export * from "./0021.vue?vue&type=script&lang=js&"
import style0 from "./0021.vue?vue&type=style&index=0&id=99622798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99622798",
  null
  
)

export default component.exports